/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallsService {
  constructor(public messageHandler: DotNetRequestMessageService) {}

  public onCloseWindow(nameOfWindowMethod: string): Observable<boolean> {
    const result = from<Promise<boolean>>(this.messageHandler.sendRequestAsync(nameOfWindowMethod));
    return result;
  }

  public onWindowResize(nameOfWindowMethod: string, height: number, width?: number): Observable<boolean> {
    let result;
    if (width === undefined) {
      result = from<Promise<boolean>>(this.messageHandler.sendRequestAsync(nameOfWindowMethod, [height]));
    } else {
      result = from<Promise<boolean>>(this.messageHandler.sendRequestAsync(nameOfWindowMethod, [width, height]));
    }

    return result;
  }
}
